import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/shared/shared.module';
import { WorkforceAddStaffModalComponent } from './workforce-add-staff-modal.component';
import { WorkforceAddStaffLookupStepComponent } from './workforce-add-staff-lookup-step/workforce-add-staff-lookup-step.component';
import { WorkforceAddStaffAddedStepComponent } from './workforce-add-staff-added-step/workforce-add-staff-added-step.component';
import { WorkforceCreatePersonStepComponent } from './workforce-create-person-step/workforce-create-person-step.component';
import { WorkforcePositionLabelModule } from '../workforce-position-label/workforce-position-label.module';

@NgModule({
  declarations: [
    WorkforceAddStaffModalComponent,
    WorkforceAddStaffLookupStepComponent,
    WorkforceAddStaffAddedStepComponent,
    WorkforceCreatePersonStepComponent,
  ],
  imports: [CommonModule, SharedModule, WorkforcePositionLabelModule],
  exports: [WorkforceAddStaffModalComponent, WorkforceCreatePersonStepComponent],
})
export class WorkforceAddStaffModule {}
